import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import './BatchingPlant.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Shared/Searchbar.css';
import axios from 'axios';
import GoCast from '../../Images/GoCast.png';

function BatchingPlant() {
    const [isLoading, setIsLoading] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [tableVisible, setTableVisible] = useState(true);
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [modifiedData, setModifiedData] = useState([]);
    const [modifiedRows, setModifiedRows] = useState(new Set());
    const [partNumFilter, setPartNumFilter] = useState('');
    const [fromEstimatedCastingDate, setFromEstimatedCastingDate] = useState('');
    const [toEstimatedCastingDate, setToEstimatedCastingDate] = useState('');
    const [concreteMix, setConcreteMix] = useState('');
    const [concreteApiData, setConcreteApiData] = useState([]);
    const [isCollapsed, setIsCollapsed] = useState(false); // Add this state
    const [filter, setFilter] = useState(''); // Element ID Filter


    
    const handleFilterChange = (e) => {
        const inputValue = e.target.value.toLowerCase(); // Convert input value to lowercase
        setFilter(inputValue);

        // Filter apiData based on the input value, ensuring ElementID is defined
        const filteredData = apiData.filter(item => item.JobHead_PartNum && item.JobHead_PartNum.toLowerCase().includes(inputValue));
        setModifiedData(filteredData.map(item => ({ ...item }))); // Update modifiedData with filtered data
    };
    const fetchData = async () => {
        setIsLoading(true);
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_BatchingPlanner_v3(PRECAST)';

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            if (Array.isArray(data.value)) {
                setApiData(data.value);
                setModifiedData(data.value.map(item => ({ ...item })));
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchConcreteData = async () => {
        setIsLoading(true);
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_Part_Samaa';

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            if (Array.isArray(data.value)) {
                setConcreteApiData(data.value);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        fetchConcreteData();
    }, []);

    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    };

    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    };

    const saveData = async () => {
        setIsLoading(true);
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_BatchingPlanner_v3(PRECAST)';

        try {
            for (const rowIndex of modifiedRows) {
                const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
            }
        } catch (error) {
            console.error('Error:', error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e, index, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index)));
    };

    const handleSelectChange = (e, index) => {
        const newValue = e.target.value;
        const newData = [...modifiedData];
        newData[index]['JobMtl_PartNum'] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index)));
    };

    const goToPage = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, apiData.length);
        const currentItems = apiData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={startIndex + index}>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_JobNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_JobNum')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].PartLot_LotNum} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_LotNum')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_PartNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_PartNum')} disabled /></td>

                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].PartLot_EstimatedCastingDate_c ? modifiedData[startIndex + index].PartLot_EstimatedCastingDate_c.split('T')[0] : ''} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_EstimatedCastingDate_c')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_ProdQty} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_ProdQty')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_IUM} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_IUM')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_QtyPer} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_QtyPer')} disabled /></td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_IUM} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_IUM')} disabled /></td>
                <td>
                    <select
                        className="UpdateInput"
                        value={modifiedData[startIndex + index].JobMtl_PartNum}
                        onChange={(e) => handleSelectChange(e, startIndex + index)}
                    >
                        {concreteApiData.map((option, idx) => (
                            <option key={idx} value={option.Part_PartNum}>
                                {option.Part_PartDescription}
                            </option>
                        ))}
                    </select>
                </td>
                <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].Part_PartNum} onChange={(e) => handleInputChange(e, startIndex + index, 'Part_PartNum')} disabled /></td>
            </tr>
        ));
    };

    const renderPageNumbers = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        const maxPageNumbersToShow = 3;
        let pageNumbers = [];

        let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    onClick={() => goToPage(i)}
                    className={`pagination-btn ${i === currentPage ? 'active' : ''}`}
                >
                    {i}
                </button>
            );
        }

        return (
            <div className="pagination-controls">
                <button onClick={goToPreviousPage} disabled={currentPage === 1} className='pre-nex'>
                   Previous
                </button>
                {pageNumbers}
                <button onClick={goToNextPage} disabled={currentPage === totalPages} className='pre-nex'>
                    Next
                </button>
            </div>
        );
    };

    return (
        <div className={`card rebartable-BP ${isCollapsed ? 'collapsed' : ''}`}>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header-BP">
          <div className='box-1'>
          <button className="btn" id='toggle' onClick={() => setIsCollapsed(!isCollapsed)}>
                        <FontAwesomeIcon icon={isCollapsed ? faArrowDown : faArrowUp} />
                    </button>
                    <input type='text' placeholder=' Element ID' className='Search-Input-batching' onChange={handleFilterChange} />
              
              
          </div>
          <div>
          <button className="btn" id='save' onClick={saveData}>
                        <FontAwesomeIcon icon={faSave} />
                    </button>
          </div>

                
                   
                    <Tooltip
                        anchorSelect="#save"
                        content="Save"
                        place='bottom'
                    />
                    
              
            </div>
            {!isCollapsed && tableVisible && (
                <div className="card-body-BP">
                    <div className="table-responsive scrollable-table-body">
                    
                        <table className="table table-bordered-BP">
                            <thead className='table-primary'>
                                <tr className='bg-primary text-white'>
                                    <th>Job Number</th>
                                    <th>Element Number</th>
                                    <th>Part Number</th>
                                    <th>Required By</th>
                                    <th>Prod Qty</th>
                                    <th>UOM</th>
                                    <th>Batched Qty</th>
                                    <th>Mtl UOM</th>
                                    <th>Concrete Mix</th>
                                    <th>Mtl</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTableRows()}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination-batching">
                        <div className="items-per-page">
                            <label htmlFor="itemsPerPage">Show </label>
                            <select className='mx-1'
                                id="itemsPerPage"
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                            <label htmlFor="itemsPerPage"> entries</label>
                        </div>
                        {renderPageNumbers()}
                    </div>
                </div>
            )}
        </div>
    );
}

export default BatchingPlant;
